import React from 'react'
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import DesignerTabs from "./Tabs";

const Home = () => {
  return (
    <div>
        <DesignerTabs/>
    </div>
  )
}

export default Home